import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconSpriteModule } from '@personal-area/icon-sprite';

const RADIUS = 10;
const PERCENT_TO_RADIAN_MULTIPLIER = 0.01 * Math.PI * 2;

@Component({
  selector: 'global-circle-progress',
  templateUrl: './circle-progress.component.html',
  styleUrls: ['./circle-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, IconSpriteModule],
})
export class CircleProgressComponent {
  @Input() iconSrc = '';
  @Input() context: 'pending' | 'reject' | 'success' = 'success';
  @Input() set progressPercent(percent: number) {
    if (percent >= 100) {
      this.arcData = 'M21 11 a10,10 0 1,0 -20,0 a 10,10 0 1,0 20,0';
    } else if (percent <= 0) {
      this.arcData = '';
    } else {
      const radian = percent * PERCENT_TO_RADIAN_MULTIPLIER;
      const progressEndX = RADIUS * (Math.cos(radian) - 1);
      const progressEndY = RADIUS * Math.sin(radian);
      const smallArcFlag = percent <= 50 ? 0 : 1;

      this.arcData = `M21 11 a10 10 0 ${smallArcFlag} 1 ${progressEndX},${progressEndY}`;
    }
  }

  protected arcData = '';
}
